export enum MenuState {
  Open = 'OPEN',
  Closed = 'CLOSED'
}
